import { lightTheme } from "../../../theme/theme";
type Theme = typeof lightTheme;

export const SmallCardStyles = (theme: Theme) => {
  const cardBase: React.CSSProperties = {
    marginTop: 18,
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: 14,
    background: theme.card3,
    borderRadius: 14,
    maxWidth: 380,
  };
  return {
    icon: {
      width: 36,
      height: 36,
      borderRadius: 10,
      background: theme.color1,
      color: theme.color2,
      display: "grid",
      placeItems: "center",

      flexShrink: 0,
    } as const,

    cardText: { lineHeight: 1.2 },

    cardSmall: { color: theme.muted, fontSize: 12, marginBottom: 4 },

    link: {
      fontFamily: '"Poppins", serif',
      color: theme.text,
      fontWeight: 600,
    },

    emailCard: cardBase,

    cardLink: {
      ...cardBase,
      textDecoration: "none",
      color: theme.text,
      cursor: "pointer",
      transition:
        "transform .12s ease, box-shadow .12s ease, opacity .12s ease",
      display: "flex",
    } as const,
  };
};
